'use strict';
var ClosestDivision, Geocoder, Location, SearchBar, SearchBarView, base, base1, base2, setTranslations;

SearchBarView = require('./views/desktop_search');

Location = require('../../../../../src/frontend/helper/search/helper/m_location_helper');

ClosestDivision = require('../../../../../src/frontend/helper/search/common/m_closest_division');

setTranslations = require('../../../../../src/frontend/helper/search/helper/m_typeahead_helper.coffee').setTranslations;

Geocoder = require('../../../../../src/frontend/helper/search/common/m_geocoder');

module.exports = SearchBar = {
  Autocomplete: {},
  init: function(options) {
    SearchBar.GOOGLE_GEO_URL = options.google_geo_url;
    Location.setDivision(options.division);
    setTranslations(Groupon.LS.translations);
    if ($('form#ls-search-form').length) {
      return new SearchBarView();
    }
  }
};

$(function() {
  var searchConfig;
  if ((searchConfig = Groupon.Modules.SearchBar.Config)) {
    return Groupon.Modules.SearchBar.init(searchConfig);
  }
});

if ((base = window.Groupon).Utils == null) {
  base.Utils = {};
}

Object.assign(Groupon.Utils, {
  ClosestDivision: ClosestDivision,
  Geocoder: Geocoder
});

if ((base1 = window.Groupon).Modules == null) {
  base1.Modules = {};
}

if ((base2 = window.Groupon.Modules).SearchBar == null) {
  base2.SearchBar = {};
}

Object.assign(window.Groupon.Modules.SearchBar, SearchBar);

